import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import BookTripDetails from './BookTripDetails'
import BookTripFlextime from './BookTripFlextime'
import MyLocation from '../comps/MyLocation.js'
import TripInfoFinal from '../comps/TripInfoFinal'
import {AppContext} from '../context/AppContext'

const BookTripFinal = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)
  const {tripDetails, prevPage, setPrevPage, nextPage, setNextPage, infoShow, setInfoShow} = useContext(AppContext)
  setInfoShow(true)

  return (
   <div id="booktrip-done" className="content">
          <h2>Your time has been set</h2>
          <TripInfoFinal />
            <div className="button-group">
              <Link to="/" className="button ok-button"><h3>Get boarding pass</h3></Link>
              <Link to="/" className="button ok-button"><h3>To main page</h3></Link>
            </div>
      </div>
  )
}

export default BookTripFinal
